/* 销量排行榜 */
import React from 'react'

import getLinkHref from 'lib/get-link-href'
import { sendTeaCommEvent } from 'lib/tea-analyze'

import Header from './common/header'
import CarList from './common/car-list'

import { ICarList } from './interface'

interface IProps {
  sales: ICarList[]
}

export default function SalesLeaderborard({ sales }: IProps) {
  return (
    <div className="hotspot">
      <Header
        leftContent="销量排行榜"
        rightContent="总榜单"
        href="/leaderboard/sales"
        as={getLinkHref('/sales')}
        icon="sale"
        onClick={() => {
          sendTeaCommEvent('click_sale_series_rank_list_more')
        }}
      />
      <div className="list">
        {sales.map((item: ICarList, index: number) => (
          <CarList
            list={item}
            key={item.series_name}
            isOrigin={false}
            index={index + 1}
            from="click_sale_series_rank_list"
          />
        ))}
      </div>
      <style jsx>
        {`
          .hotspot {
            margin-bottom: 10px;
          }
          .list {
            padding-bottom: 16px;
          }
        `}
      </style>
    </div>
  )
}
